import { Chip } from '@heroui/react';

export const ProductBadge = ({ text }: { text: string }) => {
  return (
    <div className="absolute top-3 left-3">
      <Chip size="sm" color="danger" variant="solid" radius="sm">
        {text}
      </Chip>
    </div>
  );
};
